
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 7410 3900"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#b22234","d":"M0 0h7410v3900H0z"}}),_c('path',{attrs:{"d":"M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0","stroke":"#fff","stroke-width":"300"}}),_c('path',{attrs:{"fill":"#3c3b6e","d":"M0 0h2964v2100H0z"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"e"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M247 90l70.534 217.082-184.66-134.164h228.253L176.466 307.082z"}}),_c('use',{attrs:{"xlink:href":"#a","y":"420"}}),_c('use',{attrs:{"xlink:href":"#a","y":"840"}}),_c('use',{attrs:{"xlink:href":"#a","y":"1260"}})]),_c('use',{attrs:{"xlink:href":"#a","y":"1680"}})]),_c('use',{attrs:{"xlink:href":"#b","x":"247","y":"210"}})]),_c('use',{attrs:{"xlink:href":"#c","x":"494"}})]),_c('use',{attrs:{"xlink:href":"#d","x":"988"}}),_c('use',{attrs:{"xlink:href":"#c","x":"1976"}}),_c('use',{attrs:{"xlink:href":"#e","x":"2470"}})])])
          )
        }
      }
    